import CryptoJS from 'crypto-js'
export default {
  getIvHide() {
    return CryptoJS.enc.Utf8.parse("uB3h7Nj6gO4yZfW2");
  },

  getKeyHide(){
    return CryptoJS.enc.Utf8.parse("uB3h7Nj6gO4yZfW2");
  }
}